import { useSelector } from "react-redux";

// Guard against silent "undefined_undefined" boutique keys: if either
// `schema` (Redux-loaded async) or `selectedRows[0].shopId` (table render
// timing) is missing, the resulting key would pollute the template store
// and round-trip back to the API. Consumers should also render-block on
// `hasValidBoutique` until both parts are available.
export function useGuardedBoutique(
    selectedRows: any
): {
    schema: string;
    shopId: string | undefined;
    boutique: string;
    hasValidBoutique: boolean;
} {
    const schema: string = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const shopId = selectedRows?.[0]?.shopId;
    const hasValidBoutique = Boolean(schema && shopId);
    const boutique = hasValidBoutique ? `${schema}_${shopId}` : "";
    return { schema, shopId, boutique, hasValidBoutique };
}
